(function () {
  var STORAGE_KEY = 'np-intl-modal-dismissed';
  var ALLOWED_COUNTRIES = ['CA', 'US'];
  var CONTACT_URL = '/pages/contact';
  var CLOSE_DURATION = 300; /* matches --duration-medium in base.css */

  function injectStyles() {
    if (document.getElementById('np-intl-modal-styles')) return;

    var style = document.createElement('style');
    style.id = 'np-intl-modal-styles';
    style.textContent =
      '.np-intl-modal-overlay {' +
      'position: fixed;' +
      'inset: 0;' +
      'z-index: 9999;' +
      'display: flex;' +
      'align-items: center;' +
      'justify-content: center;' +
      'padding: var(--spacing-4);' +
      '}' +

      '.np-intl-modal-overlay::before {' +
      'content: "";' +
      'position: absolute;' +
      'inset: 0;' +
      'background-color: rgba(var(--color-foreground), 0.6);' +
      'opacity: 0;' +
      'transition: opacity var(--duration-medium) ease;' +
      '}' +

      '.np-intl-modal-overlay--visible::before {' +
      'opacity: 1;' +
      '}' +

      '.np-intl-modal {' +
      'position: relative;' +
      'width: 100%;' +
      'max-width: 44rem;' +
      'background-color: var(--color-primary);' +
      'color: var(--color-text);' +
      'padding: var(--spacing-7);' +
      'opacity: 0;' +
      'transform: translateY(var(--spacing-3));' +
      'transition: opacity var(--duration-medium) ease, transform var(--duration-medium) ease;' +
      '}' +

      '.np-intl-modal-overlay--visible .np-intl-modal {' +
      'opacity: 1;' +
      'transform: translateY(0);' +
      '}' +

      '.np-intl-modal__close {' +
      'position: absolute;' +
      'top: var(--spacing-4);' +
      'right: var(--spacing-4);' +
      'width: var(--spacing-6);' +
      'height: var(--spacing-6);' +
      'display: inline-flex;' +
      'align-items: center;' +
      'justify-content: center;' +
      'background-color: transparent;' +
      'border: none;' +
      'padding: 0;' +
      'margin: 0;' +
      'cursor: pointer;' +
      'font-family: var(--font-body-family);' +
      'font-size: var(--font-size-h5);' +
      'line-height: 1;' +
      'color: var(--color-text);' +
      '}' +

      '.np-intl-modal__title {' +
      'font-family: var(--font-accent-family);' +
      'font-size: var(--font-size-h5);' +
      'font-weight: var(--weight-regular);' +
      'margin: 0 var(--spacing-6) var(--spacing-4) 0;' +
      '}' +

      '.np-intl-modal__text {' +
      'font-family: var(--font-body-family);' +
      'font-size: var(--font-size-p-lg);' +
      'font-weight: var(--weight-regular);' +
      'line-height: 1.5;' +
      'margin: 0 0 var(--spacing-4);' +
      '}' +

      '.np-intl-modal__list {' +
      'font-family: var(--font-body-family);' +
      'font-size: var(--font-size-p-lg);' +
      'font-weight: var(--weight-regular);' +
      'line-height: 1.6;' +
      'margin: 0 0 var(--spacing-6);' +
      'padding-left: var(--spacing-5);' +
      '}' +

      '.np-intl-modal__list li + li {' +
      'margin-top: var(--spacing-1);' +
      '}' +

      '.np-intl-modal__actions {' +
      'display: flex;' +
      'flex-wrap: wrap;' +
      'gap: var(--spacing-4);' +
      '}' +

      '.np-intl-modal__btn {' +
      'flex: 1 1 auto;' +
      'text-align: center;' +
      '}' +

      '.np-intl-modal__remember {' +
      'display: inline-flex;' +
      'align-items: center;' +
      'gap: var(--spacing-2);' +
      'margin-top: var(--spacing-4);' +
      'cursor: pointer;' +
      '}' +

      '.np-intl-modal__remember-input {' +
      'position: absolute;' +
      'width: 1px;' +
      'height: 1px;' +
      'margin: -1px;' +
      'padding: 0;' +
      'overflow: hidden;' +
      'clip: rect(0, 0, 0, 0);' +
      'white-space: nowrap;' +
      'border: 0;' +
      '}' +

      '.np-intl-modal__remember-box {' +
      'position: relative;' +
      'width: var(--spacing-4);' +
      'height: var(--spacing-4);' +
      'flex-shrink: 0;' +
      'border: 1px solid var(--color-text);' +
      '}' +

      '.np-intl-modal__remember-box::after {' +
      'content: "";' +
      'position: absolute;' +
      'top: 1px;' +
      'right: 1px;' +
      'bottom: 1px;' +
      'left: 1px;' +
      'background-color: transparent;' +
      'transition: background-color var(--duration-short) ease;' +
      '}' +

      '.np-intl-modal__remember-input:checked + .np-intl-modal__remember-box::after {' +
      'background-color: var(--color-text);' +
      '}' +

      '.np-intl-modal__remember-input:focus-visible + .np-intl-modal__remember-box {' +
      'outline: var(--focused-base-outline);' +
      'outline-offset: var(--focused-base-outline-offset);' +
      '}' +

      '.np-intl-modal__remember-text {' +
      'font-family: var(--font-body-family);' +
      'font-size: var(--font-size-caption);' +
      'font-weight: var(--weight-regular);' +
      'color: var(--color-text);' +
      '}';

    document.head.appendChild(style);
  }

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'np-intl-modal-overlay';

    overlay.innerHTML =
      '<div class="np-intl-modal" role="dialog" aria-modal="true" aria-labelledby="np-intl-modal-title">' +
      '<button type="button" class="np-intl-modal__close" aria-label="Close" data-np-intl-modal-close>&times;</button>' +
      '<h2 class="np-intl-modal__title" id="np-intl-modal-title">International Shipping</h2>' +
      '<p class="np-intl-modal__text">We currently ship to Canada and USA only. For international shipping, please contact us with the following information:</p>' +
      '<ul class="np-intl-modal__list">' +
      '<li>Full shipping address</li>' +
      '<li>Product name(s) and quantity</li>' +
      '<li>Your email address</li>' +
      '</ul>' +
      '<div class="np-intl-modal__actions">' +
      '<a href="' + CONTACT_URL + '" class="btn btn--primary-ghost np-intl-modal__btn" data-np-intl-modal-contact>Contact Us</a>' +
      '</div>' +
      '<label class="np-intl-modal__remember">' +
      '<input type="checkbox" class="np-intl-modal__remember-input" data-np-intl-modal-remember>' +
      '<span class="np-intl-modal__remember-box" aria-hidden="true"></span>' +
      '<span class="np-intl-modal__remember-text">Don’t show again</span>' +
      '</label>' +
      '</div>';

    return overlay;
  }

  function closeModal(overlay, remember) {
    if (remember) {
      try {
        localStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {}
    }

    overlay.classList.remove('np-intl-modal-overlay--visible');
    window.setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, CLOSE_DURATION);
  }

  function showModal() {
    injectStyles();

    var overlay = buildModal();
    document.body.appendChild(overlay);

    window.requestAnimationFrame(function () {
      overlay.classList.add('np-intl-modal-overlay--visible');
    });

    var rememberInput = overlay.querySelector('[data-np-intl-modal-remember]');

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeModal(overlay, rememberInput.checked);
      }
    });

    overlay.querySelector('[data-np-intl-modal-close]').addEventListener('click', function () {
      closeModal(overlay, rememberInput.checked);
    });

    overlay.querySelector('[data-np-intl-modal-contact]').addEventListener('click', function () {
      if (rememberInput.checked) {
        try {
          localStorage.setItem(STORAGE_KEY, 'true');
        } catch (e) {}
      }
    });
  }

  function init() {
    var dismissed;
    try {
      dismissed = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      dismissed = null;
    }
    if (dismissed) return;

    fetch('/browsing_context_suggestions.json')
      .then(function (response) {
        if (!response.ok) throw new Error('browsing_context_suggestions request failed');
        return response.json();
      })
      .then(function (data) {
        var country =
          data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle;

        if (!country) return;
        if (ALLOWED_COUNTRIES.indexOf(country.toUpperCase()) === -1) {
          showModal();
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
